module.exports = __webpack_public_path__ + "media/slot-game/red-pocket-c6e8ec39.svg";